import React from 'react';
export function Header() {
  return <header className="w-full py-4 border-b border-gray-100 bg-[#FAFAF8]" data-id="element-59">
      <div className="max-w-[720px] mx-auto px-4 md:px-0" data-id="element-60">
        <span className="text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-61">
          Advertorial | Huisdieren
        </span>
      </div>
    </header>;
}